import styled from 'styled-components';

export const Container = styled.div`
  align-self: center;
  margin-bottom: 30px;

  label {
    cursor: pointer;
    position: relative;
    display: flex;

    justify-content: center;

    width: 120px;
    height: 120px;
    border-radius: 50%;
    background: #eee;

    &:hover {
      img {
        opacity: 0.4;
      }
      div + div {
        z-index: 3;
      }
    }

    img {
      width: 120px;
      height: 120px;
      border-radius: 50%;
      border: 3px solid rgba(255, 255, 255, 0.3);
      z-index: 2;
      object-fit: cover;
    }

    div {
      position: absolute;
      top: 32%;
      z-index: 1;
      text-align: center;

      font: 700 20px 'Roboto', sans-serif;
      color: #444;
    }

    div + div {
      z-index: -1;
    }

    input {
      display: none;
    }
  }
`;
